<ng-container *ngIf="viewReady$ | async">
    <div class="tw-z-50 tw-grid tw-gap-2">
        <app-stackable-notification-card
            *ngFor="let notification of (temporaryNotifications$ | async); trackBy: track" [notification]="notification">
        </app-stackable-notification-card>
        <ng-container *ngIf="(permanentNotifications$ | async)?.length">
            <app-stackable-notification-card
                *ngFor="let permNotification of (permanentNotifications$ | async); trackBy: track" [notification]="permNotification">
            </app-stackable-notification-card>
        </ng-container>
    </div>
</ng-container>
